import useTranslation from '@space-core/hooks/useTranslation'
import { customMedia } from '@space-core/styles'
import ErrorState from '@space-shell/modules/home/components/errorState'
import styled from 'styled-components'

import MyProgressLoader from '../myProgressLoader'

type ErrorStateComponentProps = {
  onTryAgain: () => void
}

const Wrapper = styled.div`
  margin-bottom: calc(var(--spacer-8) * 2);

  ${customMedia.lessThan('md')`
    margin-bottom: var(--spacer-8);
  `}
`

const ErrorStateComponent = ({ onTryAgain }: ErrorStateComponentProps) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <ErrorState
        title={t('home.error_state.title.my_progress')}
        description={t('home.error_state.description')}
        textButton={t('error_state.text_button')}
        onTryAgain={onTryAgain}
        contentLoader={<MyProgressLoader />}
      />
    </Wrapper>
  )
}

export default ErrorStateComponent
